// configuracion de firebase
import { initializeApp } from 'firebase/app';
import { getFirestore } from '@firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
// json con parametros de firebase
const firebaseConfig = {
  apiKey: 'AIzaSyAOFprTCA7Hjg6bxXVpmZ9eSYUyQhSEt8M',
  authDomain: 'pizzeria-45208.firebaseapp.com',
  projectId: 'pizzeria-45208',
  storageBucket: 'pizzeria-45208.appspot.com',
  messagingSenderId: '109575160762',
  appId: '1:109575160762:web:4c1e69fca3aa0a7dc0d383',
};

// pasamos el json como parametro
const app = initializeApp(firebaseConfig);
// nos conectamos a la base de datos y ya la podemos usar importandola en un componente
export const db = getFirestore(app);
// servicio de autenticacion
export const auth = getAuth(app);
// servicio de almacenamiento de archivos (imagenes, word etc.)
export const storage = getStorage(app);
/* REGLAS DE SEGURIDAD DATABASE FIREBASE.
se hace desde un archivo llamado firestore.rules
una ves que tenemos todas las reglas listas hacemos
firebase deploy y asi se actualiza todo. (con plan de pago
con plan gratuito lo hacemos directamente desde chrome las
reglas)
la config de firebase tiene las ultimas lineas como mas importantes
la primera y segunda pone limitaciones a algunos documentos, y la
ultima una condicion q da true o false
match se usa para crear una nueva regla, seguido de la coleccion
y el documento donde vamos a aplicar la regla. pero si queremos aplicar
la regla a todos los docs de una coleccion y no a uno en especifico 
ponemos /products/{producto} {

} (esto entre llaves se reemplaza x el documento en el que se este
aplicando la regla. es dinamico igual q react funciona.
allow = permitir leer,escribir,crear si la condicion es verdadera.
allow read, write,create: if true;
tmb se puede escribir separado para ser mas especificos. 
allow read: if true;
allow write: if true;
tmb podemos ser todavia mas  especificos,  y leer un doc (get) o
varios doc (list):
allow get o list.
y escribir un doc creandolo,eliminandolo o update.:
allow create, delete, update

para hacer que no se puedan acceder a los datos de firebase si no estas
con la sesion iniciada: allow read,write if request.auth = null; 
(el igual esta tachado)
request es para indicar que hacemos una solicitud para manipular los 
datos (osea para leer o escribir.) auth para referirnos a la authenticacion
y = null para decir que si la autenticacion no es nulla (osea q la sesion
  esta iniciada, entonces se aplica la regla.)

para que el usuario solo pueda ingresar a sus datos y no a todos (una ves
iniciada su sesion) hacemos esto:
match /usuarios/{usuario} {
allow write: if request.auth.uid == usuario; permitimos la escritura  si el
id de la sesion iniciada es exactamente == a el id del usuario
en la coleccion.

tmb podemos poner reglas para un doc x ej: si queremos que los productos
que valgan + de  100 no se puedan eliminar:

resource hace referencia a la informacion del documento. 
data a los datos del doc
y precio es el doc 
permiti eliminar solo si el precio es < 100
allow delete: if resource.data.precio < 100;

tmb podemos evaluar la info que nos trae el usuario para evitar q x ej 
cambien el precio etc.
ej: si el nombre que teniamos es = al nombre que puso el usuario te acepto
la modificacion.
allow update: if request.resource.data.name = resource.data.name ;

si queremos que solo 1 persona (osea el administrador) pueda eliminar
  productos x ej:
con get traemos el usuario que es administrador y que tenemos en la base
de datos. /usuarios es la coleccion y buscamos el id con request.auth.id
con get() y exit(), y buscamos que el rol sea igual a "super-admin"
1) el path se pone completo:
get(/usuarios/{request.auth.uid}) pero con el path completo adelante q
sale de arriba de todo en las reglas. 
2) la sintaxis del path es diferente ya que {database} pasa a ser
$(database) se escribe asi xq en 

allow delete: if  get(/databases/$(database)/documents/usuarios/{request.auth.uid}).data.rol == "super-admin"
ahora si no queremos hacer tanta validacion y hacemos un doc especialmente
para las personas con admin entonces ponemos exist() que es para saber si
existe el id ya puede cambiar precios etc.
queda asi:
allow delete: if  get(/databases/$(database)/documents/usuarios/{request.auth.uid})


si tenemos una subcoleccion y adentro un doc y queremos acceder a este, 
no hace falta poner toda la ruta xq es un monton, podemos hacer que una
misma regla se aplique para paths hijos ej:

match /productos/{producto=**} {
allow read, write: if true;
match /devoluciones/{devolucion}{ (aca ponemos el path hijo de producto)
allow read, write: if true; y aca la misma regla que la anterior que es la
que queremos aplicar.
}
}
COMODINES: {producto=**} hace que todo lo que este dentro de productos
(incluyendo productos) tenga aplicada la regla que pongamos dentro (asi
que si tenemos una subcolleccion etc se aplica a todo.) OJO podemos tener
un comodin por regla

si hubiera 2 reglas contradictorias entre si, se tomaria siempre la que
diga if true. 

si no queremos repetir reglas, podemos usar funciones que retornen esa
regla ej:
match /databases/{database}/documents {
function evaluarX (){
return if bla bla (del if para delante se pone) (ojo solo permite 1 return
firebase)
}
match /productos/{producto=**} {
allow read, write: if evaluarX();

hasOnly(), hasAny(), hasAll()

match/productos/{producto}{
permitimos crear un documento solo si los datos que pasa el usuario tienen
estas categorias
  allow create: if request.resource.data.hasAll(["name","age","sku"])
}
match/productos/{producto}{
permitimos crear un documento solo si los al menos un dato que  pasa el
usuario tienen estas categorias
  allow create: if request.resource.data.hasAny(["name","age","sku"])
}
match/productos/{producto}{
permitimos crear un documento solo si las categorias son alguna de estas, si es
otra como "kaka" no se permite.
  allow create: if request.resource.data.hasOnly(["name","age","sku"])
}

para hacer que ciertos Datos correspondan a cierto tipo x ej numeros etc:
&& = y 
con eso podemos seguir evaluando abajo otros campos

allow create: if request.resource.data.cantidad is int &&
request.resource.data.precio is int &&
request.resource.data.nombre is string

tmb se puede hacer con arrays o maps ej:
la propiedad array en la posicion 0 sea entero
allow create: if request.resource.data.arraysito[0] is int
*/
